/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase, fontSize, paletteHD, enterpriseCSS,
} from './variables';

export const DeliveryHoursStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        // Delivery Hours
        DeliveryHoursStyle: {
            border: `2px solid ${newPalette.grey7}`,
            borderRadius: '4px',
            padding: `${unitBase * 2}px`,
            display: 'flex',
            alignItems: 'center',
            fontSize: fontSize.small,
            justifyContent: 'space-between',
            '& svg': {
                paddingRight: unitBase,
            },
            '& .deliveryLabel': {
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
                fontWeight: 700,
                color: newPalette.grey4,
                '& svg': {
                    verticalAlign: 'middle',
                    width: '24px',
                },
            },
            '& > div': {
                '& > div': {
                    display: 'inline-block',
                    lineHeight: '16px',
                },
                '& > svg': {
                    color: enterpriseCSS.palette.gray2,
                    width: '16px',
                },
            },
        },
    };
};
